if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    //fancybox
    $('.fancybox-terms').fancybox({
        wrapCSS : 'full-fancy-copy',
        maxWidth: 800,
    });

    $(".video-iframe").on('click', function(event) {
        event.preventDefault();
        $.fancybox({
            'type' : 'iframe',
            // hide the related video suggestions and autoplay the video
            'href' : this.href.replace(new RegExp('watch\\?v=', 'i'), 'embed/') + '?rel=0&autoplay=1',
            'overlayShow' : true,
            'centerOnScroll' : true,
            'speedIn' : 100,
            'speedOut' : 50,
            'allowfullscreen':true,
            'width'         : '900px',
            'height'        : '500px',
            'autosize': false,
            'iframe' : {
                preload: false
            }
        });
    });

    $('.fancybox-full').fancybox({
        allowfullscreen:true,
        fitToView:false, 
        padding:0,
        width:'100%',
        height:'100%'
    });


})();